import { Location } from '@core/Router/locations';
import { lazy } from 'react';

const BillingPageContainer = lazy(() =>
    import(/* webpackChunkName: "billing" */ '@billing/ui/BillingPage').then(m => ({ default: m.BillingPage })),
);
const PaymentActPrinterPageContainer = lazy(() =>
    import(/* webpackChunkName: "billing" */ '@common/Billing/PaymentActPrinter/PaymentActPrinterPage').then(m => ({
        default: m.PaymentActPrinterPage,
    })),
);

export const billingLocations: Location[] = [
    {
        url: '/billing',
        Component: BillingPageContainer,
    },
    {
        url: '/billing/payment-act',
        Component: PaymentActPrinterPageContainer,
    },
];
